import actionCreatorFactory from 'typescript-fsa';
import { ApiFieldError } from 'src/types';

export const actionCreator = actionCreatorFactory(
  `@@LENDSMARTMANAGER/INCOMPLETEAPPADVISOR`
);
type APIError = ApiFieldError;
export const allIncompleteLoanAppsRequest = actionCreator('request');

export const allIncompleteLoanAppsRequestSuccess = actionCreator<any>('success');

export const allIncompleteLoanAppsRequestFail =
  actionCreator<APIError[]>('fail');

export const updateIncompleteLoanApps = actionCreator<any>('update');
export const _updateIncompleteAdvisorLoanAppsInStore = actionCreator<any>(
  'update-incomplete-store'
);

export const updateMultipleIncompleteLoanApps = actionCreator<any>(
  'update-multiple-incomplete-loanApps'
);
